const baseUrl = 'https://api.cloud.nuskin.com/geoip/v1';

/**
 * This class allows us to use the NuSkin GeoIP location service in our JS code
 * @namespace GeoIPService
 */
class GeoIPService {
    constructor() {
        this.CLIENT_ID = '3eee8207a8224d4bbc1c667438269591';
        this.REQUEST_URL_COUNTRY = `${baseUrl}/country`;
        this.REQUEST_URL_CITY = `${baseUrl}/city`;
        this.data = {};
    }

    /**
     * Get the country's ISO code from the City GeoIP call
     * NOTE: This call is much more "expensive" in processing
     * and slightly in cost than the country call. Only use it
     * when you need the extra information.
     * @returns {string} ISO Code -- ex: "US"
     */
    async getByCity() {
        try {
            let city = await this.sendRequest(this.REQUEST_URL_CITY);
            this.data = city;
            if (city.country) {
                this.country = city.country.iso_code;
            }
            return city.country.iso_code ? city.country.iso_code : '';
        } catch(error) {
            return "";
        }
    }

    /**
     * Get the country's ISO code from the Country GeoIP call
     * @returns {string} ISO Code -- ex: "US"
     */
    async getByCountry() {
        try{
            let country = await this.sendRequest(this.REQUEST_URL_COUNTRY);
            this.data = country;
            if (country.country) {
                this.country = country.country.iso_code;
            }
            return country.country.iso_code ? country.country.iso_code : '';
        } catch(error) {
            return "";
        }
    }

    /**
     * Get all the data from the City GeoIP call
     * NOTE: This call is much more "expensive" in processing
     * and slightly in cost than the country call. Only use it
     * when you need the extra information.
     * @returns {object} All data returned (city, continent, country, location, postal, subdivisions, ipAddress)
     */
    async getAllCity() {
        try {
            let city = await this.sendRequest(this.REQUEST_URL_CITY);
            this.data = city;
            if (city.country) {
                this.country = city.country.iso_code;
            }
            return city;
        } catch(error) {
            return {"error": error}
        }
    }

    /**
     * Get all the data from the Country GeoIP call
     * @returns {object} All data returned (continent, country, ipAddress)
     */
    async getAllCountry() {
        try {
            let country = await this.sendRequest(this.REQUEST_URL_COUNTRY);
            this.data = country;
            if (country.country) {
                this.country = country.country.iso_code;
            }
            return country;
        } catch(error) {
            return {"error": error}
        }
    }

    sendRequest(serviceURL) {
        let deferred = $.Deferred();
        $.ajax({
            type: "GET",
            url: serviceURL,
            dataType: "json",
            headers: {
                'client_id': this.CLIENT_ID
            },
            success: data => {
                deferred.resolve(data);
            },
            error: xhr => {
                deferred.reject(xhr);
            }
        });
        return deferred.promise();
    }
}

export default new GeoIPService();